export const tableContent = [
  {
    heading: [
      {
        column: "Loan Amount (₹)",
      },
      {
        column: "Current Interest Rate (%)",
      },
      {
        column: "New Interest Rate (%)",
      },
      {
        column: "Tenure (Months)",
      },
      {
        column: "Current EMI (₹)",
      },
      {
        column: "New EMI (₹)",
      },
      {
        column: "Monthly Savings (₹)",
      },
      {
        column: "Total Savings (₹)",
      },
    ],
    rowData: [
      {
        amount: "₹5,00,000 ",
        interest: "10",
        newInterest: "8",
        Tenure: "5",
        currentEMI: " ₹10,624",
        newEMI: "₹10,138",
        monthlySaving: "₹486",
        totalSaving: " ₹29,160",
      },
      {
        amount: "₹8,00,000",
        interest: "11",
        newInterest: "8.5",
        Tenure: "7",
        currentEMI: "₹14,126 ",
        newEMI: "₹13,348",
        monthlySaving: "₹778",
        totalSaving: "₹65,352",
      },
      {
        amount: "₹12,00,000 ",
        interest: "12",
        newInterest: "9",
        Tenure: "5",
        currentEMI: " ₹26,689",
        newEMI: "₹25,014",
        monthlySaving: "₹1,675 ",
        totalSaving: " ₹1,00,500",
      },
    ],
  },
];
